import { FormattedMessage } from 'react-intl';
import { IRouteConfig } from './DataModelInterface';

export const routes: IRouteConfig = {
  ReportsAdmin: {
    path: '/reportsAdmin',
    renderBreadcrumb: () => {
      return <FormattedMessage id='menu.reports'/>;
    }
  },
  ReportAdminStatus: {
    path: '/reportsAdmin/status',
    renderBreadcrumb: () => {
      return <FormattedMessage id='reports.status'/>;
    }
  },
  ReportAdminSerty: {
    path: '/reportsAdmin/lists',
    renderBreadcrumb: () => {
      return <FormattedMessage id='reports.lists'/>;
    }
  },
  ReportAdminCompanies: {
    path: '/reportsAdmin/companies',
    renderBreadcrumb: () => {
      return <FormattedMessage id='reports.companies'/>;
    }
  },
  ReportAdminOngoing: {
    path: '/reportsAdmin/ongoing',
    renderBreadcrumb: () => {
      return <FormattedMessage id='reports.ongoing'/>;
    }
  },
  ReportAdmin: {
    path: '/reportsAdmin/reportAdmin',
    renderBreadcrumb: (state: any) => {
      const period = state.period;
      const year = period.split("-")[0];
      const month = period.split("-")[1];
      const timePeriod = period ? ": " + month + "/" + year : '';
      return <><FormattedMessage id='report.header'/>{timePeriod}</>;
    }
  },
  ReportAdminCompany: {
    path: '/reportsAdmin/reportAdminCompany',
    renderBreadcrumb: (state: any) => {
      const name = state.companyName ? ' - ' + state.companyName : '';
      return <><FormattedMessage id='menu.report.company'/>{name}</>;
    }
  },
  ReportAdminReportedPom: {
    path: '/reportsAdmin/reportedPom',
    renderBreadcrumb: (state: any) => {
      return <><FormattedMessage id='reports.reportedpom'/></>;
    }
  },
  Users: {
    path: '/usermanagement',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.usermanagement'/></>;
    }
  },
  User: {
    path: '/usermanagement/user',
    renderBreadcrumb: (state: any) => {
      const name = state.user?.name ? ' - ' + state.user.name : '';
      return <><FormattedMessage id='menu.user'/>{name}</>;
    }
  },
  Companies: {
    path: '/companymanagement',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.companymanagement'/></>;
    }
  },
  Company: {
    path: '/companymanagement/company',
    renderBreadcrumb: (state: any) => {
      const name = state.company?.name ? ' - ' + state.company.name : '';
      return <><FormattedMessage id='menu.company'/>{name}</>;
    }
  },
  Bookkeeping: {
    path: '/bookkeeping',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.bookkeeping'/></>;
    }
  },
  BookkeepingReport: {
    path: '/bookkeeping/companyreport',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.report.company'/></>;
    }
  },
  Categories: {
    path: '/categories',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.categories'/></>;
    }
  },
  Messages: {
    path: '/messages',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.messages'/></>;
    }
  },
  Languages: {
    path: '/languages',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.languages'/></>;
    }
  },
  MailTemplates: {
    path: '/languages/templates',
    renderBreadcrumb: () => {
      return <FormattedMessage id='languages.templates'/>;
    }
  },
  Infos: {
    path: '/languages/infos',
    renderBreadcrumb: () => {
      return <FormattedMessage id='languages.infos'/>;
    }
  },
  Settings: {
    path: '/settings',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.settings'/></>;
    }
  },
  Profile: {
    path: '/profile',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.profile'/></>;
    }
  },
  CompanyInfo: {
    path: '/profile/companyinfo',
    renderBreadcrumb: (state: any) => {
      const name = state?.company?.name ?  ' - ' + state.company.name : '';
      return <><FormattedMessage id='menu.profile.companyinfo'/>{name}</>;
    }
  },
  Reports: {
    path: '/reports',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.reports'/></>;
    }
  },
  Report: {
    path: '/reports/report',
    renderBreadcrumb: (state: any) => {
      const period = state.period;
      const year = period.split("-")[0];
      const month = period.split("-")[1];
      const timePeriod = period ? " - " + month + "/" + year : '';
      const name = state.companyName ? state.companyName : '';
      return (
        <>
          { name ? (<>{name}{timePeriod}</>) : <FormattedMessage id='menu.report.company'/>}
        </>
      );
    }
  },
  Home: {
    path: '/home',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.home'/></>;
    }
  },
  PrivacyStatement: {
    path: '/home/privacystatement',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='info.privacystatement'/></>;
    }
  },
  Login: {
    path: '/',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.login'/></>;
    }
  },
  Error: {
    path: '/error',
    renderBreadcrumb: () => {
      return <><FormattedMessage id='menu.errorpage'/></>;
    }
  }
};


